import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CustomInput from "../../../CustomInput/CustomInput";
import CustomSelect from "../../../CustomSelect/CustomSelect";
import styles from "./AddTelegramModal.module.scss";
import CustomButton from "../../../CustomButton/CustomButton";
import InformationIcon from "../../../../assets/icons/InformationIcon";
import { useTranslation } from "react-i18next";
import {
  createChannel,
  createTelegramChannel,
} from "../../../../api/telegramApi";
import { useNotification } from "../../../../contexts/NotificationToast";

const StepForm = ({ step, setStep, setOpenModal, minStep }) => {
  const [data, setData] = useState();
  const { showNotification } = useNotification();
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors, isValid },
    trigger,
  } = useForm({
    defaultValues: {
      botToken: "",
      botName: "",
      botRole: "",
      botInstructions: "",
      botGreeting: "",
      botTask: "",
      botLanguage: "All",
    },
    mode: "onChange",
  });

  useEffect(() => {
    const newData = getValues();
    setData({
      bot_token: newData.botToken,
      bot_username: newData.botName,
      greeting_message: newData.botGreeting,
      prompt: `${newData.botRole} ${newData.botTask} ${newData.botInstructions}`,
      language: newData.botLanguage,
      description: newData.botRole,
    });
  }, [step]);

  const languageOptions = [
    { value: "all", label: "All" },
    { value: "en", label: "English" },
    { value: "ru", label: "Russian" },
    { value: "de", label: "German" },
  ];

  const handlePreviousStep = () => {
    if (step === 1) {
      return;
    } else {
      setStep((prev) => prev - 1);
    }
  };

  const handleNextStep = async () => {
    const isStepValid = await trigger();
    if (isStepValid) {
      if (step < 6) {
        setStep((prev) => prev + 1);
      } else {
        return;
      }
    }
  };

  const onSubmit = async () => {
    if (step === 6) {
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.from}>
      {step === 1 && (
        <div className={styles.formSecondStep}>
          <CustomInput
            label={"Bot name"}
            placeholder={"Bot name"}
            onChange={(e) => setValue("botName", e.target.value)}
            name="botName"
            {...register("botName", { required: t("form.botRoleRequired") })}
            error={errors.botRole ? errors.botRole.message : null}
          />

          <CustomInput
            label={t("form.botInstructionsLabel")}
            placeholder={t("form.botInstructionsPlaceholder")}
            value={watch("botInstructions")}
            {...register("botInstructions", {
              required: t("form.botInstructionsRequired"),
            })}
            error={
              errors.botInstructions ? errors.botInstructions.message : null
            }
          />
          <div className={styles.stepInfo}>
            <InformationIcon />
            <p>
              <span className="bold">{t("form.exampleTitle")}</span>:{" "}
              {t("form.exampleDescription")}
            </p>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className={styles.formSecondStep}>
          <CustomInput
            label={t("form.botRoleLabel")}
            placeholder={t("form.botRolePlaceholder")}
            onChange={(e) => setValue("botRole", e.target.value)}
            name="botRole"
            {...register("botRole", { required: t("form.botRoleRequired") })}
            error={errors.botRole ? errors.botRole.message : null}
          />

          <CustomInput
            label={t("form.botGreetingLabel")}
            placeholder={t("form.botGreetingPlaceholder")}
            value={watch("botGreeting")}
            {...register("botGreeting", {
              required: t("form.botGreetingRequired"),
            })}
            error={errors.botGreeting ? errors.botGreeting.message : null}
          />

          <div className={styles.stepInfo}>
            <InformationIcon />
            <p className={styles.textInfo}>{t("form.greetingDescription")}</p>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className={styles.formSecondStep}>
          <CustomInput
            label={t("form.botRoleLabel")}
            value={watch("botRole")}
          />
          <CustomInput
            label={t("form.botTaskLabel")}
            placeholder={t("form.botTaskPlaceholder")}
            value={watch("botTask")}
            {...register("botTask", { required: t("form.botTaskRequired") })}
            error={errors.botTask ? errors.botTask.message : null}
          />

          <div className={styles.stepInfo}>
            <InformationIcon />
            <div>
              <p className={styles.textInfo}>
                <span className="bold">{t("form.taskTitle")}</span>
              </p>

              <p className={styles.textInfo}>
                <span className="bold">{t("form.example")}</span>:{" "}
                {t("form.exampleDescriptionTask")}
              </p>
            </div>
          </div>
        </div>
      )}

      {step === 4 && (
        <div className={styles.formSecondStep}>
          <CustomInput
            label={t("form.botRoleLabel")}
            value={watch("botRole")}
          />
          <div className={styles.languageSelectContainer}>
            <label>{t("form.languageLabel")}</label>
            <CustomSelect
              width={"30%"}
              placeholder={t("form.languagePlaceholder")}
              onChange={(value) => setValue("botLanguage", value)}
              options={languageOptions}
            />
          </div>
          <div className={styles.stepInfo}>
            <InformationIcon />
            <p className={styles.textInfo}>{t("form.languageDescription")}</p>
          </div>
        </div>
      )}

      {step === 5 && (
        <div className={styles.formData}>
          <CustomInput label={"Bot name"} value={watch("botName")} />
          <CustomInput
            label={t("form.botRoleLabel")}
            value={watch("botRole")}
          />
          <CustomInput
            label={t("form.botInstructionsLabel")}
            value={watch("botInstructions")}
          />
          <CustomInput
            label={t("form.botGreetingLabel")}
            value={watch("botGreeting")}
          />
          <CustomInput
            label={t("form.botTaskLabel")}
            value={watch("botTask")}
          />
          <CustomInput
            label={t("form.languageLabel")}
            value={watch("botLanguage")}
          />
        </div>
      )}

      <div className={styles.modalFooter}>
        <CustomButton onClick={handlePreviousStep}>
          {t("form.previousButton")}
        </CustomButton>
        <CustomButton blue onClick={handleNextStep} disabled={!isValid}>
          {t("form.nextButton")} {">"}
        </CustomButton>
      </div>
    </form>
  );
};

export default StepForm;
